module.exports = __webpack_public_path__ + "img/machine.5eea35d6.svg";